import cls from './Cloudes.module.scss';
import cloudOneImage from '../../assets/images/cloud-1.svg';
import cloudTwoImage from '../../assets/images/cloud-2.svg';

const Cloudes = () => {
  return (
    <div className={cls.container}>
      <div className={cls.CloudesOne}>
        <img alt="cloud" src={cloudOneImage} className={cls.cloudOneImage} />
        <img alt="cloud" src={cloudTwoImage} className={cls.cloudTwoImage} />
        <img alt="cloud" src={cloudTwoImage} className={cls.cloudThreeImage} />
        <img alt="cloud" src={cloudOneImage} className={cls.cloudForImage} />
        <img alt="cloud" src={cloudTwoImage} className={cls.cloudFiveImage} />
        <img alt="cloud" src={cloudTwoImage} className={cls.cloudSixImage} />
        <img alt="cloud" src={cloudOneImage} className={cls.cloudSevenImage} />
        <img alt="cloud" src={cloudOneImage} className={cls.cloudEightImage} />
        <img alt="cloud" src={cloudTwoImage} className={cls.cloudNineImage} />
        <img alt="cloud" src={cloudOneImage} className={cls.cloudTenImage} />
      </div>
      <div className={cls.CloudesTwo}>
        <img alt="cloud" src={cloudOneImage} className={cls.cloudOneImage} />
        <img alt="cloud" src={cloudTwoImage} className={cls.cloudTwoImage} />
        <img alt="cloud" src={cloudTwoImage} className={cls.cloudThreeImage} />
        <img alt="cloud" src={cloudOneImage} className={cls.cloudForImage} />
        <img alt="cloud" src={cloudTwoImage} className={cls.cloudFiveImage} />
        <img alt="cloud" src={cloudTwoImage} className={cls.cloudSixImage} />
        <img alt="cloud" src={cloudOneImage} className={cls.cloudSevenImage} />
        <img alt="cloud" src={cloudOneImage} className={cls.cloudEightImage} />
        <img alt="cloud" src={cloudTwoImage} className={cls.cloudNineImage} />
        <img alt="cloud" src={cloudOneImage} className={cls.cloudTenImage} />
      </div>
    </div>
  );
};

export default Cloudes;
